import React from 'react'
import logo3 from '../../images/logo3.svg'
import { Link } from 'react-router-dom'


function ForgotPassword() {
  return (
    <div >
        <div className="hold-transition login-page" style={{backgroundColor:"rgb(17, 24, 39)"}}>
        <div
          className="login-box"
          style={{
            width: 800,
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            backgroundImage:
              "url('https://wallpaperaccess.com/full/187161.jpg')",
            backgroundSize: "contain",
            backgroundColor: "rgba(0,0,0,0.7)",
            backgroundBlendMode: "darken",
            borderRadius: 10,
            border: "2px solid #007bff",
            padding: 20,
          }}
        >
          <div
            style={{
              width: 450,
              padding: 25,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
            }}
          >
            <h1
              style={{
                fontSize: 48,
                color: "#fff",
                fontFamily: "Arial",
                fontWeight: 700,
              }}
            >
              Welcome to <br />
              Admin Panel
            </h1>
            <p style={{ fontSize: 14, color: "#fff", fontFamily: "Arial" }}>
              This admin panel or a control panel is a system that enables
              administrators and workers to conduct various tasks
              like monitoring, maintaining, and controlling certain business
              processes.
            </p>
          </div>
          {/* /.login-logo */}
          <div
            className="card"
            style={{ width: 380, backgroundColor: "rgba(255,255,255,0.9)" }}
          >
            <div
              className="card-header text-center"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img src={logo3} alt="logo" style={{ width: 200 }} />
            </div>
            <div className="card-body">
              <p className="login-box-msg">You forgot your password? Here you can easily retrieve a new password.</p>
              <form action="recover-password.html" method="post">
                <div className="input-group mb-3">
                  <input type="email" className="form-control" placeholder="Email" />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-envelope" />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <button type="submit" className="btn btn-primary btn-block">Request new password</button>
                  </div>
                  {/* /.col */}
                </div>
              </form>
              <p className="mt-3 mb-1">
                <Link to="/login">Login</Link>
              </p>
            </div>
            {/* /.login-card-body */}
          </div>
        </div>
      </div>
      
    </div>
  )
}

export default ForgotPassword
